<template>
  <div class="wrapper-dashboard-inside text-left">
    <div class="bg text-left">
      <h1>{{ $t('pages.dashboards.candidate.hello', { name: $auth.user().first_name}) }}</h1>
      <Search />
    </div>

    <b-overlay
      :show="isLoading"
      opacity="0.8"
      spinner-small
      spinner-variant="primary"
    >
      <div class="row new-info text-left">
        <div class="col info-card">
          <h3 class="--bold">
            <span class="number">
              {{
                paginationMeta && paginationMeta.total
                  ? paginationMeta.total
                  : 0
              }}
            </span>
            {{ $t('pages.dashboards.candidate.stat-cards.offers.title') }}
          </h3>
          <p>
            {{
              paginationMeta && paginationMeta.total
                ? paginationMeta.total
                : 0
            }} {{ $t('pages.dashboards.candidate.stat-cards.offers.subtitle') }}
          </p>
        </div>
        <div class="col info-card">
          <h3 class="--bold">
            {{ $t('pages.dashboards.candidate.stat-cards.cv.title') }}
          </h3>
          <p>
            {{ $t('pages.dashboards.candidate.stat-cards.cv.subtitle') }}
          </p>
          <router-link :to="{ name: 'my-cv'}">
            {{ $t('pages.dashboards.candidate.stat-cards.cv.link') }}
          </router-link>
        </div>
        <div class="col info-card">
          <h3 class="--bold">
            <span class="number">{{ activeCandidaturasCount }}</span> {{ $t('pages.dashboards.candidate.stat-cards.applications.title') }}
          </h3>
          <p>{{ $t('pages.dashboards.candidate.stat-cards.applications.subtitle') }}</p>
          <router-link :to="{ name: 'applied-offers'}">
            {{ $t('pages.dashboards.candidate.stat-cards.applications.link') }}
          </router-link>
        </div>
      </div>

      <div
        v-if="offersList"
        class="offers"
      >
        <h1>{{ $t('pages.dashboards.candidate.new-offers.title') }}</h1>
        <div
          v-for="offer in offersList"
          :key="offer.id"
        >
          <OfferCard
            :offer="offer"
          />
        </div>
        <div v-if="offersList.length === 0">
          {{ $t('pages.dashboards.candidate.new-offers.no-offers') }}
        </div>
        <pagination
          v-if="paginationMeta"
          :data="paginationMeta"
          size="small"
          :limit="1"
          align="center"
          @pagination-change-page="getResults"
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

import Search from '@/components/Home/Search';
import OfferCard from '@/components/Home/OfferCard';

export default {
  components: {
    Search,
    OfferCard
  },
  data() {
    return {
      paginationMeta: null,
      activeCandidaturasCount: 0
    }
  },
  computed: {
    ...mapGetters('offers', {
      offerLoading: 'isLoading',
      offersList: 'list'
    }),

    ...mapState([
      'route', // vuex-router-sync
    ]),

    appName() {
      return process.env.VUE_APP_NAME;
    },

    isLoading() {
      return !this.paginationMeta || typeof this.paginationMeta.total !== "number";
    }
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.fetchData();
    this.getActiveCandidaturasCount();
  },
  methods: {
    ...mapActions('offers', {
      fetchOffers: 'fetchList',
    }),
    fetchData() {
      return this.fetchOffers({ customUrl: '/offer/my-new-offers' })
        .then(response => {
          if (response.meta) {
            this.paginationMeta = response.meta
          }
        })
        .catch(() => {
          this.$toastSomethingWentWrong();
        });
    },
    getResults(page){
      const config = {
        params: {
          page: page
        },
      };

    this.$store.dispatch('offers/fetchList', { config })
    .then((res) => {
      this.paginationMeta = res.meta;
      window.scrollTo(0,200);
    })
    },
    // SEARCH
    doSearch() {
      this.$router.push({ name: 'search-offers', query: { provinces: this.provinceSelected, keyword: this.search.keyword } });
    },
    generateSlug(offerProp) {
      let slug;
      if(offerProp.titleTitle) {
        slug = offerProp.titleTitle.replace(/[^A-Z0-9]+/ig, "-").toLowerCase()  +
        '/' + offerProp.locationProvince.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
      }
      else slug = "";
      return slug;
    },
    getActiveCandidaturasCount() {
      this.axios.get('/offerApply/getActiveCandidaturasCount')
        .then( response => {
          this.activeCandidaturasCount = response.data;
        });
    }
  }
}
</script>


<style scoped lang="scss">
  .bg {
    background: url('../../../assets/user-dashboard-search.png');
    padding: 2rem;
  }

  .search-card {
    background: rgba(22,125,183,0.7);
    border-radius: 7px;
  }

  .new-info {
    margin: -5px;

    .info-card {
      padding: 20px;
      background: #f2f2f2;
      margin: 10px 5px;

      span.number {
        font-size: 2.2rem;
        font-weight: 400;
      }

      p {
        font-size: 0.9rem;
        margin-bottom: 10px;
      }
    }
  }

  .offers {
    background: #f2f2f2;
    text-align: left;
    padding: 3rem;

    .offer {
      font-size: 0.9rem;
      padding: 1rem 2rem;
      transition: 0.4s ease;
      background: #fff;
      margin-bottom: 1rem;

      &:hover {
        background: #f6fafc !important;
      }

      .companyName {
        color: #666;
        text-decoration: underline;
      }

      .offerLink {
        color: unset !important;
        text-decoration: none;
      }
    }
  }

  .wrapper-dashboard-inside {
    padding: 0;

    @media screen and (min-width: 768px) {
      padding: 40px;
    }
  }
</style>
